<template>
    <div>
        <v-card-title>
            <h2>Create Report</h2>
        </v-card-title>
        <div>
            <v-stepper
                v-model="step"
            >
                <v-stepper-header
                    style="box-shadow: unset;-webkit-box-shadow:unset;border-bottom: 1px solid #26262626;height: 84px;"
                >
                    <v-divider
                        style="border-color: #1976d2;margin: 0 -25px;"
                    />
                    <v-stepper-step
                        :complete="step > 1"
                        step="1"
                        :complete-icon="report_type && report_type !='custom' ? report_types.filter(r => r.key == report_type)[0].icon : ''"
                    >
                        Select a Report Type
                        <small
                            v-if="report_type && report_type != 'custom'"
                        >
                            {{report_types.filter(r => r.key == report_type)[0].name}}
                        </small>
                        <small
                            v-else-if="report_type && report_type == 'custom'"
                        >
                            Custom Report
                        </small>
                    </v-stepper-step>
                    <v-divider />
                    <v-stepper-step
                        :complete="step > 2"
                        step="2"
                    >
                        Filters &amp; Properties
                    </v-stepper-step>
                    <v-divider />
                    <v-stepper-step
                        :complete="step > 3"
                        step="3"
                    >
                        Run
                    </v-stepper-step>
                    <v-divider />
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <div>
                            <v-alert
                                :value="true"
                                type="warning"
                            >
                                Reports now expire after completion. The days a report will remain available are shown on the Report Types below.
                            </v-alert>
                            <v-layout row wrap>
                                <v-flex
                                    lg4
                                    md6
                                    sm12
                                    v-for="report in report_types"
                                    :key="report.key"
                                    style="padding: 10px;"
                                >
                                    <v-card
                                        style="display: inline-block;height: 100px;width: 100%;border: 2px solid #1976d226;cursor:pointer;position:relative;"
                                        :class="{ 'selected': report_type == report.key }"
                                        @click="report_type = report.key"
                                    >
                                        <v-card-text>
                                            <v-icon
                                                size="64"
                                                style="float:left;padding-right: 10px;"
                                                :color="report_type == report.key ? 'primary': ''"
                                            >
                                                {{report.icon}}
                                            </v-icon>
                                            <div
                                                style="vertical-align:middle;"
                                            >
                                                <h2>{{report.name}}</h2>
                                                <p>
                                                    {{report.desc}}
                                                </p>
                                            </div>
                                            <div
                                                style="font-size: 10px;position:absolute;right:5px;top:5px;"
                                            >
                                                
                                                <v-icon
                                                    size="16"
                                                >
                                                    mdi-delete-clock
                                                </v-icon>
                                                {{settings.reports && settings.reports[report.key] ? settings.reports[report.key].expire : '...'}} days
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                            <v-layout
                                v-if="settings.reports && settings.reports.custom && settings.reports.custom.length > 0"
                                style="margin: 10px;margin-top: 20px;border-radius: 10px;background: rgba(0,0,0,0.02);padding: 10px;"
                                row
                                wrap
                            >
                                <v-flex
                                    sm12
                                    style="display: flex;align-items: center;"
                                >
                                    <div>
                                        <v-icon
                                            size="32"
                                            style="float:left;padding-right: 10px;"
                                        >
                                            mdi-beta
                                        </v-icon>
                                    </div>
                                    <div>
                                        <div
                                            style="font-weight: bold;"
                                        >
                                            Mapping Reports
                                        </div>
                                        <div class="caption grey--text">
                                            Custom reports built by {{ app_name }} Support for your organization's specific needs, such as submission mapping or specialized data exports.<br />
                                            This is a beta feature. Please contact {{ app_name }} Support to request the creation of a custom report for your organization.
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex
                                    lg4
                                    md4
                                    sm12
                                    v-for="report in settings.reports.custom"
                                    :key="report.id"
                                    style="padding: 10px;"
                                >
                                    <v-card
                                        style="display: inline-block;width: 100%;border: 2px solid #1976d226;cursor:pointer;position:relative;"
                                        :class="{ 'selected': report_type == 'custom' && custom_report_id == report.id }"
                                        @click="report_type = 'custom';custom_report_id = report.id"
                                    >
                                        <v-card-text>
                                            <div
                                                style="vertical-align:middle;"
                                            >
                                                <div>{{report.name}}</div>
                                                <p
                                                    style="font-size: 10px;margin: unset;"
                                                >
                                                    {{report.short_desc}}
                                                </p>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="report_type == null"
                                color="primary"
                                @click="step++"
                            >
                                Continue
                            </v-btn>
                        </v-card-actions>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <div v-if="report_type">
                            <div
                                v-if="report_type == 'custom'"
                            >
                                <h2>Build Custom Report</h2>
                                <div
                                    style="display: flex;align-items: center;margin: 20px 0;border-radius: 10px;background: rgba(0,0,0,0.04);padding: 10px;"
                                >
                                    <div>
                                        <v-icon
                                            size="32"
                                            style="float:left;padding-right: 10px;"
                                        >
                                            mdi-beta
                                        </v-icon>
                                    </div>
                                    <div
                                        style="display: flex;flex-direction: column;flex-grow: 1;"
                                    >
                                        <div
                                            style="font-weight: bold;"
                                        >
                                            This feature is in Beta
                                        </div>
                                        <div class="caption grey--text">
                                            Please contact {{ app_name }} Support if you have any questions, experience any issues, or otherwise need assistance with this custom report type.
                                        </div>
                                        <div
                                            style="margin-top: 10px;padding-top: 10px;border-top: 2px solid rgba(0,0,0,0.1);min-width: 100%;"
                                        >
                                            <h3>{{ settings.reports.custom.filter(r => r.id == custom_report_id)[0].name }}</h3>
                                            <div>
                                                <div v-html="settings.reports.custom.filter(r => r.id == custom_report_id)[0].desc" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-else
                            >
                                <h2>Build {{report_types.filter(r => r.key == report_type)[0].name}}</h2>
                            </div>
                            <div
                                v-if="selectedReport.file_upload"
                                style="border: 2px solid #1976d226;margin-bottom: 10px;border-radius: 4px;"
                            >
                                <v-toolbar
                                    flat
                                    dense
                                    color="#1976d226"
                                    style="border-radius: unset;"
                                >
                                    <b>{{selectedReport.file_title}}</b>
                                </v-toolbar>
                                <v-card-text>     
                                    <input 
                                        type="file" 
                                        @change="selectedReport.file_upload = $event.target.files[0]" 
                                    />
                                    <div
                                        style="padding-top: 10px;"
                                    >
                                        <div class="caption grey--text" v-html="selectedReport.file_desc"></div>
                                    </div>
                                </v-card-text>
                            </div>
                            <v-card
                                v-if="selectedReportFilters.length > 0"
                                style="border: 2px solid #1976d226;margin-bottom: 10px;border-radius: 4px;"
                            >
                                <v-toolbar
                                    flat
                                    dense
                                    color="#1976d226"
                                    style="border-radius: unset;"
                                >
                                    <b>
                                        Filters
                                    </b>
                                </v-toolbar>
                                <v-card-text>                                    
                                    <v-layout row wrap>
                                        <v-flex
                                            v-for="f in selectedReportFilters"
                                            :key="f.prop"
                                            style="padding: 10px;padding-top: unset;"
                                            v-show="visible(f)"
                                            xs12
                                        >
                                            <div
                                                v-if="f.type == 'checkbox'"
                                            >
                                                <v-checkbox
                                                    v-model="f.value"
                                                    item-text="name"
                                                    item-value="value"
                                                    :label="f.title"
                                                    :hint="f.hint"
                                                    :disabled="saving"
                                                    flat
                                                    persistent-hint
                                                    style="margin-top: unset"
                                                />
                                            </div>
                                            <div
                                                v-if="f.type == 'field'"
                                            >
                                                <FormTemplateFieldSelector
                                                    v-if="fieldSelector"
                                                    filter="file"
                                                    :templateID="report_types.find(r => r.key == report_type).filters.find(r => r.prop == f.scope).value"
                                                    @select="f.value = arguments[0];fieldSelector = false"
                                                    @cancel="fieldSelector = false"
                                                />
                                                <v-input
                                                    :rules="f.required ? [value => !!value || 'Required!'] : []"
                                                    :value="f.value"
                                                    style="width: 100%;"
                                                >
                                                    <div
                                                        v-if="f.value"
                                                        @click="fieldSelector=true"
                                                        style="cursor: pointer;padding: 10px;border-radius: 3px;border: 1px solid rgba(0,0,0,0.1);width: 100%;"
                                                    >
                                                        <b>Question ID:</b> {{ f.value.question_id }}<br />
                                                        <b>Fieldtype ID:</b> {{ f.value.fieldtype_id }}
                                                    </div>
                                                    <div
                                                        v-else
                                                    >
                                                        <v-btn
                                                            :disabled="!report_types.find(r => r.key == report_type).filters.find(r => r.prop == f.scope).value"
                                                            @click="fieldSelector=true"
                                                            color="primary"
                                                        >
                                                            Select Field
                                                        </v-btn>
                                                    </div>
                                                </v-input>
                                            </div>
                                            <div
                                                v-if="f.type == 'dropdown'"
                                            >
                                                <v-autocomplete
                                                    v-model="f.value"
                                                    :items="f.options"
                                                    :label="f.title"
                                                    :hint="f.hint"
                                                    item-text="name"
                                                    item-value="value"
                                                    small-chips
                                                    persistent-hint
                                                    :rules="f.required ? [value => !!value || 'Required!'] : []"
                                                    :multiple="f.multiple || false"
                                                    :disabled="saving"
                                                    deletable-chips
                                                    hide-selected
                                                    auto-select-first
                                                />
                                            </div>
                                            <div
                                                v-if="f.type == 'casetype'"
                                            >
                                                <v-autocomplete
                                                    v-model="f.value"
                                                    :items="f.results"
                                                    :label="f.title"
                                                    :search-input.sync="f.search"
                                                    :hint="f.hint"
                                                    :rules="f.required ? [value => !!value || 'Required!'] : []"
                                                    :disabled="saving"
                                                    :return-object="false"
                                                    item-text="name"
                                                    item-value="value"
                                                    persistent-hint
                                                    hide-selected
                                                    auto-select-first
                                                    @focus="tagFocused = f"
                                                    @input="f.search = ''"
                                                >
                                                    <template slot="no-data">
                                                        <div
                                                            class="autocomplete-no-data"
                                                        >
                                                            <div
                                                                v-if="f.search"
                                                            >
                                                                <i>No results for '{{ f.search }}'</i>
                                                            </div>
                                                            <div
                                                                v-else
                                                            >
                                                                Start typing to search
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-autocomplete>
                                            </div>
                                            <div
                                                v-if="f.type == 'tags'"
                                            >
                                                <v-combobox
                                                    v-model="f.value"
                                                    :items="f.results"
                                                    :label="f.title"
                                                    :search-input.sync="f.search"
                                                    :hint="f.hint"
                                                    :rules="f.required ? [value => !!value || 'Required!'] : []"
                                                    :disabled="saving"
                                                    :multiple="f.multiple || false"
                                                    :deletable-chips="f.multiple || false"
                                                    chips
                                                    :return-object="false"
                                                    item-text="tag"
                                                    item-value="tag"
                                                    persistent-hint
                                                    hide-selected
                                                    auto-select-first
                                                    @focus="tagFocused = f"
                                                    @input="f.search = ''"
                                                />
                                            </div>
                                            <div
                                                v-if="f.type == 'template'"
                                            >
                                                <v-autocomplete
                                                    v-model="f.value"
                                                    :items="f.results"
                                                    :label="f.title"
                                                    :search-input.sync="f.search"
                                                    :hint="f.hint"
                                                    :rules="f.required ? [value => !!value || 'Required!'] : []"
                                                    :disabled="saving"
                                                    :return-object="false"
                                                    item-text="name"
                                                    item-value="value"
                                                    persistent-hint
                                                    hide-selected
                                                    auto-select-first
                                                    @focus="tagFocused = f"
                                                    @input="f.search = ''"
                                                >
                                                    <template slot="no-data">
                                                        <div
                                                            class="autocomplete-no-data"
                                                        >
                                                            <div
                                                                v-if="f.search"
                                                            >
                                                                <i>No results for '{{ f.search }}'</i>
                                                            </div>
                                                            <div
                                                                v-else
                                                            >
                                                                Start typing to search
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-autocomplete>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-card
                                v-if="selectedReportProperties.length > 0"
                                style="border: 2px solid #1976d226;margin-bottom: 10px;border-radius: 4px;"
                            >
                                <v-toolbar
                                    flat
                                    dense
                                    color="#1976d226"
                                    style="border-radius: unset;"
                                >
                                    <b>
                                        Properties
                                    </b>
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex
                                            v-for="p in selectedReportProperties"
                                            :key="p.prop"
                                            style="padding: 10px;padding-top: unset;"
                                            xs12
                                        >
                                            <div
                                                v-if="p.type == 'text'"
                                            >
                                                <v-text-field
                                                    v-model="p.value"
                                                    item-text="name"
                                                    item-value="value"
                                                    :label="p.title"
                                                    :hint="p.hint"
                                                    :disabled="saving"
                                                    flat
                                                    persistent-hint
                                                    style="margin-top: unset"
                                                />
                                            </div>
                                            <div
                                                v-if="p.type == 'naming'"
                                            >
                                                <div>
                                                    Click on a placeholder below to insert it into your naming convention. Do not modify the text inside the brackets.<br />
                                                    <br />
                                                    You can use forward slashes <b>(/)</b> to define directory structure.<br /><br />
                                                    If the field is a list, this defines the directory structure only. Files will not be renamed from a list field download.<br /><br />
                                                    File extensions are not modified in this download. Do not add a file extension below, it will be ignored.
                                                </div>
                                                <div>
                                                    <v-chip
                                                        @click="p.value = p.value + '{contact.id}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Contact: ID
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{contact.full_name}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Contact: Name
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{contact.first_name}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Contact: First Name
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{contact.last_name}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Contact: Last Name
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{contact.cuid}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Contact: CUID
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{case.id}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Case: ID
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{case.case_number}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Case: Case Number
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{case.case_title}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Case: Case Title
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{form.id}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Form: ID
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{form.form_number}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Form: Form Number
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{form.party_name}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        Form: Party Name
                                                    </v-chip>
                                                    <v-chip
                                                        @click="p.value = p.value + '{file.name}'"
                                                        style="cursor: pointer;"
                                                    >
                                                        File: Name (Original)
                                                    </v-chip>
                                                </div>
                                                <v-text-field
                                                    v-model="p.value"
                                                    persistent-hint
                                                    :label="p.title"
                                                    :rules="p.required ? [value => !!value && value !== '' || 'Required!'] : []"
                                                    :hint="p.hint"
                                                />
                                            </div>
                                            <div
                                                v-if="p.type == 'checkbox'"
                                            >
                                                <v-checkbox
                                                    v-model="p.value"
                                                    item-text="name"
                                                    item-value="value"
                                                    :label="p.title"
                                                    :hint="p.hint"
                                                    :disabled="saving"
                                                    flat
                                                    persistent-hint
                                                    style="margin-top: unset"
                                                />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-card-actions>
                                <v-btn
                                    v-if="$route.query.copy"
                                    @click="$router.go(-1)"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    v-else
                                    @click="step--"
                                >
                                    Back
                                </v-btn>
                                <v-spacer />
                                <v-btn
                                    :disabled="canNextStep()"
                                    color="primary"
                                    @click="runReport()"
                                >
                                    Run Report
                                </v-btn>
                            </v-card-actions>
                        </div>
                        <div
                            v-else
                        >
                            <div
                                class="text-xs-center"
                                style="padding: 25px;"
                            >
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                ></v-progress-circular>
                                <br />
                                <br />
                                Copying Report Details...
                            </div>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <div
                            v-if="report"
                        >
                            <v-progress-linear
                                v-model="report.progress"
                                :indeterminate="report.status == 'new'"
                                :color="reportColor(report)"
                                height="10"
                            ></v-progress-linear>
                            <div
                                v-if="report.status == 'new'"
                            >
                                <h3>Report #{{report.id}} has been queued.</h3>
                                <p>Your report is waiting for an available worker. You can leave this page, you'll receive a notification when this report is complete.</p>
                            </div>
                            <div
                                v-if="report.status == 'running'"
                            >
                                <h3>Report #{{report.id}} is processing...</h3>
                                <p>Large reports may take up to two hours to process. You can leave this page, you'll receive a notification when this report is complete.</p>
                            </div>
                            <div
                                v-if="report.status == 'failed'"
                            >
                                <h3>Report #{{report.id}} failed.</h3>
                                <p>
                                    Report failures may occur to a missing requirement or a time out.<br />
                                    If this continues to occur, please contact {{ app_name }} support at help@litigationlocker.com with the below information.
                                </p>
                                <br />
                                <div
                                    style="font-family: monospace;border: 1px solid red;background: rgba(0,0,0,0.05);padding: 5px;"
                                >
                                    <b>Report #:</b> {{report.id}}<br />
                                    <b>Type:</b> {{report.type}}<br />
                                    <b>Error:</b> {{report.error}}
                                </div>
                            </div>
                            <div
                                v-if="report.status == 'finished'"
                            >
                                <h3>Report #{{report.id}} has completed.</h3>
                                <div>
                                    <v-card-actions>
                                        <v-spacer />
                                        <v-btn
                                            color="primary"
                                            @click="downloadReport(report.id, report.file_name)"
                                        >
                                            Download Report
                                        </v-btn>
                                        <v-spacer />
                                    </v-card-actions>
                                </div>
                            </div>
                        </div>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import GlobalConstants from '@/globals'
import FormTemplateFieldSelector from '../FormTemplateFieldSelector.vue'

export default {
  name: 'CreateReport',
  props: [ 'settings' ],
  components: {
    FormTemplateFieldSelector
  },
  data () {
    return {
        step: 1,
        report_type: null,
        saving: false,
        tagFocused: null,
        report: null,
        interval: null,
        fieldSelector: false,
        custom_report_id: null,
        report_types: [
            {
                name: 'Form Data Report',
                key: 'userform',
                desc: 'Build a CSV containing Form data',
                icon: 'mdi-file-table',
                filters: [
                    {
                        title: 'Form Template',
                        type: 'template',
                        scope: 'templates',
                        hint: 'Select the Form to generate a Report from',
                        prop: 'template',
                        required: true,
                    },
                    {
                        title: 'Case Type',
                        scope: 'casetypes',
                        type: 'casetype',
                        hint: 'Filter for Forms in this Case Type',
                        prop: 'casetype',
                        multiple: false,
                    },
                    {
                        title: 'Form Tags',
                        scope: 'userform',
                        type: 'tags',
                        hint: 'Filter for Forms that contain this tag',
                        prop: 'tags',
                        multiple: true,
                    },
                    {
                        title: 'Form Status',
                        type: 'dropdown',
                        hint: 'Filter for Forms in these statuses',
                        prop: 'statuses',
                        options: GlobalConstants.StatusStrings,
                        multiple: true,
                    }
                ],
                properties: [
                    {
                        title: 'Show Archived Parts',
                        type: 'checkbox',
                        hint: 'Include archived Sections and Questions in Report',
                        prop: 'show_archived',
                    },
                    {
                        title: 'Include Import Headers',
                        type: 'checkbox',
                        hint: 'Include import headers in this report for correcting and reuploading form data',
                        prop: 'include_import_headers',
                    },
                    {
                        title: 'Include Closed Cases',
                        type: 'checkbox',
                        hint: 'Include forms from closed cases in this report',
                        prop: 'include_closed_cases',
                    },
                    {
                        title: 'Convert Partial Dates',
                        type: 'checkbox',
                        hint: 'Convert Partial Dates (ie: 2019, 05/2019) into Full Dates (ie: 01/01/2019, 05/01/2019)',
                        prop: 'show_full_date',
                    },
                ]
            },
            {
                name: 'Form File Report',
                key: 'form file report',
                desc: 'Build a ZIP containing files from a form question',
                icon: 'mdi-file-download',
                filters: [
                    {
                        title: 'Form Template',
                        type: 'template',
                        scope: 'templates',
                        hint: 'Select the Form to generate a Report from',
                        prop: 'template',
                        required: true,
                    },
                    {
                        title: 'Case Type',
                        scope: 'casetypes',
                        type: 'casetype',
                        hint: 'Filter for Forms in this Case Type',
                        prop: 'casetype',
                        multiple: false,
                    },
                    {
                        title: 'Form Tags',
                        scope: 'userform',
                        type: 'tags',
                        hint: 'Filter for Forms that contain this tag',
                        prop: 'tags',
                        multiple: true,
                    },
                    {
                        title: 'Form Status',
                        type: 'dropdown',
                        hint: 'Filter for Forms in these statuses',
                        prop: 'statuses',
                        options: GlobalConstants.StatusStrings,
                        multiple: true,
                    },
                    {
                        title: 'Question Field',
                        type: 'field',
                        scope: 'template',
                        hint: 'Select the question to download files from',
                        prop: 'field',
                        required: true,
                    },
                    {
                        title: 'Exclude Reviewed Files',
                        type: 'checkbox',
                        hint: 'Exclude any file fields that are marked as reviewed.',
                        prop: 'filter_reviewed',
                    }
                ],
                properties: [
                    {
                        title: 'Naming Convention',
                        type: 'naming',
                        hint: 'Define how to name downloaded files - if a list question, this defines the folder structure, not the file name. Any duplicate names will have a number appended. File extension will not be modified.',
                        prop: 'naming',
                        scopes: ['form', 'case', 'contact'],
                        required: true,
                        value: ''
                    },
                    {
                        title: 'Review Files',
                        type: 'checkbox',
                        hint: 'Mark files downloaded in this operation as reveiwed.',
                        prop: 'set_reviewed',
                    }
                ]
            },
            {
                name: 'Contact File Report',
                key: 'contact file report',
                desc: 'Build a ZIP containing Contact files',
                icon: 'mdi-folder-zip',
                filters: [
                    {
                        title: 'Contact Tags',
                        scope: 'contact',
                        type: 'tags',
                        hint: 'Filter for Contacts that contain these Tags',
                        prop: 'tags',
                        multiple: true,
                    },
                    {
                        title: 'Include Read Files',
                        type: 'checkbox',
                        hint: 'Include Files marked as read in the Report',
                        prop: 'is_read',
                    },
                    {
                        title: 'Contact Uploads Only',
                        type: 'checkbox',
                        hint: 'Filter for Files uploaded by Contacts only',
                        prop: 'contact_upload',
                    }
                ],
                properties: [
                    {
                        title: 'Mark as Read',
                        type: 'checkbox',
                        hint: 'Mark Files in Report as read',
                        prop: 'set_read',
                    }
                ],
            },
        ]
    }
  },
  created () {
      if (this.$route.query.copy) {
        this.saving = true
        this.step = 2
        api.reports.reports.get(this.$route.query.copy)
            .then(data => {
                this.report_type = data.type
                var currentReport = this.selectedReport
                currentReport.filters.forEach(f => {
                    if (data.parsed_filters[f.prop])
                        if (f.type == 'tags')
                            if (data.parsed_filters[f.prop].id)
                            {
                                f.results = [{
                                    value: data.parsed_filters[f.prop].id,
                                    name: data.parsed_filters[f.prop].name
                                }]
                                f.value = data.parsed_filters[f.prop].id
                            }
                            else
                            {
                                f.results = data.parsed_filters[f.prop]
                                f.value = data.parsed_filters[f.prop]
                            }
                        else if (f.type == 'template')
                        {
                            f.value = data.parsed_filters[f.prop]['id']
                            f.search = data.parsed_filters[f.prop]['name']
                            this.fetchTags(f)
                        }
                        else if (f.type == 'casetype')
                        {
                            f.value = data.parsed_filters[f.prop]['id']
                            f.search = data.parsed_filters[f.prop]['name']
                        }
                        else
                            f.value = data.parsed_filters[f.prop]
                })
                currentReport.properties.forEach(p => {
                    if (data[p.prop])
                        p.value = data[p.prop]
                })
                this.saving = false                
            })
      }
  },
  watch: {
    tagFocused: {
      deep: true,
      handler () {
        if (this.tagFocused) {
          if (this.tagFocused.search) {
            this.fetchTags(this.tagFocused)
          }
        }
      }
    }
  },
  computed: {
    selectedReportProperties() {
        if (this.report_type && this.report_type != 'custom') {
            return this.report_types.find(x => x.key == this.report_type).properties
        } else if (this.report_type && this.report_type == 'custom' && this.custom_report_id) {
            return this.settings.reports.custom.find(x => x.id == this.custom_report_id).properties
        } else {
            return []
        }
    },
    selectedReportFilters() {
        if (this.report_type && this.report_type != 'custom') {
            return this.report_types.find(x => x.key == this.report_type).filters
        }
        return []
    },
    selectedReport () {
        if (this.report_type && this.report_type != 'custom') {
            return this.report_types.find(x => x.key == this.report_type)
        } else if (this.report_type && this.report_type == 'custom' && this.custom_report_id) {
            return this.settings.reports.custom.find(x => x.id == this.custom_report_id)
        } else {
            return null
        }
    }
  },
  methods: {
    visible (prop) {
      if (prop.prereq) {
        var currentReport = this.selectedReport
        return currentReport.filters.find(x => x.prop === prop.prereq).value !== undefined
      }
      return true
    },
    fetchTags (field) {
      var searchText = field.search
      if (field.scope == "userform") {
        api.userform.userformTags.get(searchText)
          .then(tagResults => {
            field.results = tagResults
            this.$forceUpdate()
          })
      } else if (field.scope == "contact") {
        api.userform.contactTags.get(searchText)
          .then(tagResults => {
            field.results = tagResults
            this.$forceUpdate()
          })
      } else if (field.scope == "templates") {
        api.formtemplate.formtemplate.list({
          search: searchText
        })
          .then(data => {
            var searchArray = []
            data.results.forEach(form => {
              searchArray.push({
                "name": form['name'],
                "value": form['id']
              })
            })
            field.results = searchArray
            this.$forceUpdate()
          })
      } else if (field.scope == "casetypes") {
        api.cases.casetype.list({
          search: searchText
        })
          .then(data => {
            var searchArray = []
            data.results.forEach(form => {
              searchArray.push({
                "name": form['name'],
                "value": form['id']
              })
            })
            field.results = searchArray
            this.$forceUpdate()
          })
      }
    },
    canNextStep() {
        var currentReport = this.selectedReport
        var blockContinue = false
        currentReport.filters.forEach(f => {
            if (f.required)
                if (f.value == undefined || f.value == null)
                    blockContinue = true
                else if (f.value instanceof Array && f.value.length == 0)
                    blockContinue = true
        })
        currentReport.properties.forEach(f => {
            if (f.required)
                if (f.value == undefined || f.value == null || f.value == "")
                    blockContinue = true
                else if (f.value instanceof Array && f.value.length == 0)
                    blockContinue = true
                else if (f.prop === 'naming'){
                    blockContinue = (() => {
                        let lastBracket = ''
                        let charsSinceBracket = 0
                        for (const char of f.value) {
                            if(char == '{' || char == '}'){
                                if(lastBracket == '{' && charsSinceBracket == 0){
                                    return true
                                }
                                if(char == lastBracket){
                                    return true
                                }
                                lastBracket = char
                                charsSinceBracket = 0  
                            }
                            else{
                                charsSinceBracket++
                            }
                        }
                        return f.value.split('{').length != f.value.split('}').length
                    })()
                }
        })
        return blockContinue
    },
    runReport() {
        this.saving = true
        var filterObject = {}
        var reportObject = {}
        var runObj = null
        var currentReport = this.selectedReport
        currentReport.filters.forEach(f => {
            if (f.value)
                filterObject[f.prop] = f.value
        })
        if (this.report_type != 'custom')
            currentReport.properties.forEach(p => {
                reportObject[p.prop] = p.value || false
            })
        else {
            reportObject['properties'] = {}
            currentReport.properties.forEach(p => {
                reportObject['properties'][p.prop] = p.value || false
            })
            reportObject['custom_report'] = this.custom_report_id
        }
        reportObject['filters'] = JSON.stringify(filterObject)
        reportObject['type'] = this.report_type
        if (this.report_type == 'userform')
            runObj = api.reports.forms
        else if (this.report_type == 'contact file report')
            runObj = api.reports.contactFile
        else if (this.report_type == 'form file report')
            runObj = api.reports.formFile
        else if (this.report_type == 'custom') {
            runObj = api.reports.custom
            const formData = new FormData()
            for (const key in reportObject) {
                if (key === 'properties' || key === 'filters') {
                    formData.append(key, typeof reportObject[key] === 'string' ? reportObject[key] : JSON.stringify(reportObject[key]))
                } else {
                    formData.append(key, reportObject[key])
                }
            }
            if (currentReport.file_upload && currentReport.file_upload) {
                formData.append('file_upload', currentReport.file_upload)
            }
            reportObject = formData
        }
        
        runObj.save(reportObject)
            .then(data => {
                this.report = data
                this.step = 3
                this.saving = false
                this.restartInterval()
            })
    },
    restartInterval() {
      clearInterval(this.interval)
      if (this.report.status !== 'finished' && this.report.status !== 'failed') {
        this.interval = setInterval(() => {
          this.update()
        }, 1500)
      }
    },
    update() {
      api.reports.reports.get(this.report.id)
        .then(data => {
          this.restartInterval()
          this.report = data
        })
    },
    downloadReport (id, name) {
      api.reports.reports.downloadReport(id)
      .then(response => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = name
        link.click()
      })
    },
    reportColor(report) {
        if (report.status == 'failed')
            return 'error'
        if (report.status == 'finished')
            return 'success'
        return 'primary'
    },
    beforeDestroy () {
        clearInterval(this.interval)
    }
  }
}
</script>

<style>
    .selected {
        background-color: #1976d226 !important;
        border-color: #1976d2 !important;
    }
</style>